export default __webpack_public_path__ + "static/media/website-icon.95e84b3f.svg";